export default {
    backgroundColor:'#EDF1F5',
    transparent:'rgba(0, 0, 0, 0)',
    purplePeel:'#E3DAFF',
    purpleRed:'#B053C9',
    darkPurple:'#5E17EB',
    softGray:'#A1A4A9',
    blueBackground:'rgb(225, 231, 238)',
    darkGray:"#777777",
    white:'#FFFFFF',
    lightGray:'#DCDDDE',
    lightGreen:'#59CD59',
    purple:'#9A6DF8',
    purpleTransparent:'rgba(197, 172, 248,1)',
    primaryColor: '#f44336ff',
    redPink:'#E9245F',
    redPinkTransparent:'rgba(233, 36, 95,0.3)',
    orange:'#FF914d',
    redOrange:'#FF6F1D',
    dark:'rgba(0,0,0)',
    transparent:'rgba(0,0,0,0)',
    lightGray:'#F0F3F4',
    softWhite:'#F4F6FA',
    one:'#FF5757',
    two:'#FA8D94',
    three:'#FFCACA',
    four:'#FFE871',
    five:'#00F39F',
    six:'#90E3FF',
    seven:'#C0CDFF',
    eight:'#C6BDF4',
    nine:'#B28DFA',
    ten:'#D9D9D9',
    header:'#D00A13',
    background:'#D00A13',
    darkTransparent7:'rgba(0,0,0,0.7)',
    darkTransparent2:'rgba(0,0,0,0.5)',
    scanFoodLightBg:'#FFDADA',
    darkRed:'#EB1818',
    redSanta:'#D00A13',
    greenSanta:'#0D8266',
    greenPeel:'#E9F4EF',
};